
import { useState, useEffect } from 'react';
import { Region, ChurchPresence } from '../data/types/region-types';
import { regions_mexico } from '../data/regions-data';
import { getFundingPercentage } from '../data/utils/region-utils';

export function useFilterState() {
  const [searchTerm, setSearchTerm] = useState('');
  const [churchPresenceFilter, setChurchPresenceFilter] = useState<ChurchPresence | 'All'>('All');
  const [fundingFilter, setFundingFilter] = useState<[number, number]>([0, 100]);
  const [filteredRegions, setFilteredRegions] = useState<Region[]>(regions_mexico);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    let filtered = regions_mexico;
    
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(region => 
        region.english_name.toLowerCase().includes(searchLower) || 
        region.spanish_name.toLowerCase().includes(searchLower)
      );
    }
    
    if (churchPresenceFilter !== 'All') {
      filtered = filtered.filter(region => region.church_presence === churchPresenceFilter);
    }
    
    filtered = filtered.filter(region => {
      const percentage = getFundingPercentage(region.pledges, region.target_need);
      return percentage >= fundingFilter[0] && percentage <= fundingFilter[1];
    });
    
    setFilteredRegions(filtered);
  }, [searchTerm, churchPresenceFilter, fundingFilter]);

  const resetFilters = () => {
    setSearchTerm('');
    setChurchPresenceFilter('All');
    setFundingFilter([0, 100]);
  };

  return {
    searchTerm,
    setSearchTerm,
    churchPresenceFilter,
    setChurchPresenceFilter,
    fundingFilter,
    setFundingFilter,
    filteredRegions,
    showFilters,
    setShowFilters,
    resetFilters
  };
}
